import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterpoliciesRoutingModule } from './masterpolicies-routing.module';
import { MasterpoliciesComponent } from './masterpolicies.component';
import { PremiumtransactionsComponent } from './premiumtransactions/premiumtransactions.component';
import { AddnewComponent } from './addnew/addnew.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../material.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [MasterpoliciesComponent, PremiumtransactionsComponent, AddnewComponent],
  imports: [
    CommonModule,
    MasterpoliciesRoutingModule,
    FormsModule,
    NgbModule,
    MaterialModule,
    MatProgressSpinnerModule
  ],
  
  exports:[
    MasterpoliciesComponent,AddnewComponent,PremiumtransactionsComponent
  ]
})
export class MasterpoliciesModule { }


